<template>
    <div class="home pure-g">
    
        <StocktakingMenu :url="url" class="pure-u-1-6"/>

        <div class="pure-u-5-6">
      
            <div class="menuBarBox">
                <div id="menuBar" class="pure-menu pure-menu-horizontal menuBar">
                    <li class="pure-menu-item"><router-link class="pure-menu-link" to="/stocktakings" >Abbrechen</router-link></li>
                    <li class="pure-menu-item"><a class="pure-menu-link" v-on:click="save" >Speichern</a></li>
                </div>
            </div>

            <div class="formBox">
                <form class="pure-form pure-form-stacked">
                    <fieldset>
                        <legend>Inventur</legend>
                        <table>
                            <tr>
                                <td style="width: 400px;">
                                    <label for="store">Filiale</label>
                                    <input id="store" style="width: 90%;" class="pure-u-10-24" type="text" v-model="store">
                                    <label for="modulePicker">Inventur Typ</label>
                                    <select id="modulePicker" v-model="selectedModule" :readonly="true">
                                    <option v-for="module in  modules" :key="module._links.self.href"  :value="module._links.self.href">{{ module.name }}</option>
                                    </select>
                                    <label for="datePicker">Datum</label>
                                    <datepicker id="datePicker" format="dd.MM.yyyy" class="pure-u-10-24 comment" v-model="date">
                                    </datepicker>
                                </td>
                                <td>
                                    <table v-if="stocktaking"  class="infoTable">
                                        <tr>
                                            <td>Anzahl F&auml;cher</td>
                                            <td>{{ stocktaking.countLocations }}</td>
                                        </tr>
                                        <tr>
                                            <td>Erstes Fach</td>
                                            <td>{{ stocktaking.minLocationScanCode }}</td>
                                        </tr>
                                        <tr>
                                            <td>Letztes Fach</td>
                                            <td>{{ stocktaking.maxLocationScanCode }}</td>
                                        </tr>
                                        <tr>
                                            <td>Erfassungen</td>
                                            <td>{{ stocktaking.countRecords }}</td>
                                        </tr>
                                        <tr>
                                            <td>Erfasste Positionen</td>
                                            <td>{{ stocktaking.countRecordItems }}</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </fieldset>

                    <fieldset>
                        <legend>F&auml;cher</legend>
                    </fieldset>

                    <div class="menuBarBox" style="margin: 0px;" >
                        <div class="pure-menu pure-menu-horizontal menuBar" style="font-weight: bolder;">
                            <li class="pure-menu-item" style="padding-right: 10px;">Fach</li>
                            <li class="pure-menu-item" style="padding-right: 15px;"><input type="search" v-model="locationSearch" style="width: 80px;"></li>
                            <li class="pure-menu-item" style="padding-right: 10px;">Erfasser</li>
                            <li class="pure-menu-item" style="padding-right: 15px;"><input type="search" v-model="staffSearch"></li>
                            <li class="pure-menu-item" style="padding-right: 10px;">F&auml;cher</li>
                            <li class="pure-menu-item" style="padding-right: 15px;">
                                <select v-model="locationFilter">
                                    <option value="all">Alle</option>
                                    <option value="recorded">Erfasste</option>
                                    <option value="missing">Fehlende</option>
                                    <option value="null">Nullf&auml;cher</option>
                                    <option value="multiple">Mehrfach erfasst</option>
                                </select>
                            </li>
                            <li class="pure-menu-item"><a style="cursor: pointer; padding-right: 10px;"><i v-on:click="clearFilter" class="material-icons md-18">highlight_off</i></a></li>
                            <li class="pure-menu-item"><a style="cursor: pointer"><i v-on:click="reload" class="material-icons md-18">search</i></a></li>
                        </div>
                    </div>


                    <div v-if="locations" class="tableBox" style="margin: 0px;">
                        <div class="pure-menu pure-menu-horizontal tableNav">
                            <li id="tableNavFirst" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadLocations(locations._links.firstPage.href)">&lt;&lt;</a></li>
                            <li id="tableNavPrev" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadLocations(locations._links.prevPage.href)">&lt;</a></li>
                            <li class="pure-menu-item">Seite {{ locations.page + 1 }} von {{ locations.pages }} &frasl; Fächer: {{ locations.total }}</li>
                            <li id="tableNavNext" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadLocations(locations._links.nextPage.href)">&gt;</a></li>
                            <li id="tableNavLast" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadLocations(locations._links.lastPage.href)">&gt;&gt;</a></li>
                        </div>
                        <table class="pure-table table">
                            <thead>
                            <tr>
                                <th id="colLocation">Fach</th>
                                <th id="colDate">Datum</th>
                                <th id="colStaff">Erfasser</th>
                                <th>gepr&uuml;ft</th>
                                <th style="text-align: right;" id="colRecords">Erfassungen</th>
                                <th style="text-align: right;" id="colRecordItems">Positionen</th>
                                <th style="width: 30px;"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="location in  locations.data " :key="location.scanCode" class="even-odd">
                                <td>{{ location.scanCode }}</td>
                                <td>{{ new Date(location.createDate).toLocaleDateString('de', { month: '2-digit', day: '2-digit', year: 'numeric' } ) }}</td>
                                <td>{{ location.staff }}</td>
                                <td v-if="location.checked">ja</td>
                                <td v-else></td>
                                <td style="text-align: right;" v-if="location.countRecords > 0">{{ location.countRecords}}</td>
                                <td v-if="location.countRecords <= 0"></td>
                                <td style="text-align: right;" v-if="location.countRecordItems > 0">{{ location.countRecordItems }}</td>
                                <td v-if="location.countRecordItems <= 0"></td>
                                <td><a v-on:click="editLocation(location)"><i class="material-icons md-18" style="cursor: pointer;">menu</i></a></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import StocktakingMenu from '@/components/StocktakingMenu'
import Datepicker from 'vuejs-datepicker'
import axios from "axios"
import router from '@/router.js'
import { getJwt } from '@/utils/auth.js'
import { toastInfo, toastError } from '@/utils/toast.js'
import { getApiUrl } from '@/utils/api.js'

export default {
    name: 'EditStocktakingView',
    components: {
        StocktakingMenu,
        Datepicker
    },
    data: function() {
        return {
            date: null,
            store: null,
            modules: [],
            selectedModule: null,
            url: null,
            stocktaking: null,
            locations: null,
            staffSearch: "",
            locationSearch: "",
            locationFilter: "all"
        }
    },
    created: function() {

        this.url = this.$route.params.url
    },
    mounted: function() {

        this.loadData(this.$route.params.url)
    },
    methods: {

        loadData: function(url) {

            axios({
                method: "GET",
                url: getApiUrl() + "/v0/modules?type=stocktaking",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + getJwt()
                }
            }).then(
                result => {

                    this.modules = result.data.data
                    console.log(this.modules)
                },
                error => {
                    toastError(error.response.data.message);
                }
            )

            axios({
                method: "GET",
                url: url,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + getJwt()
                }
            }).then(
                result => {
                    this.stocktaking = result.data
                    this.store = result.data.store
                    this.date = result.data.date
                    this.selectedModule = result.data._links.module.href
                },
                error => {
                    console.error(error.response.data.status)
                })

            axios({
                method: "GET",
                url: url + "/locations?size=25&staff=" + this.staffSearch + "&locations=" + this.locationFilter + "&location=" + this.locationSearch,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + getJwt()
                }
            }).then(
                result => {
                    console.info(result.data)
                    this.locations = result.data;
                },
                error => {
                    console.error(error.response.data.status)
                })
        },

        loadLocations: function(url) {

            axios({
                method: "GET",
                url: url,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + getJwt()
                }
            }).then(
                result => {
                    console.info(result.data)
                    this.locations = result.data;
                },
                error => {
                    console.error(error.response.data.status)
                })
        },

        reload: function() {

            this.loadData(this.url)
        },

        clearFilter : function() {

            this.locationFilter = "all"
            this.staffSearch = ""
            this.locationSearch = ""
            this.loadData(this.url)
        },

        editLocation: function(location) {

            router.push({
                name: "locationEditView",
                params: {
                    url: location._links.self.href,
                    backUrl: this.url
                }
            });
        },

        save: function() {

            console.log(this.selectedModule)

            axios({
                method: "PUT",
                url: this.$route.params.url,
                headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getJwt()
                },
                data: {
                    date: this.date,
                    store: this.store
                }
            }).then(
                result => {
                toastInfo("Inventur wurde gespeichert.");

                router.push({ name: "stocktakingView" });

                },
                error => {
                    toastError(error.response.data.message);
                }
            )
        }
    }
}
</script>

<style>

#datePicker {
    background-color: white; 
}

tr.even-odd:nth-child(even){
    color: black;
    background-color: #eeeeee;
}
tr.even-odd:nth-child(odd){
    color: black;
}

</style>
